<template>

<div class="main list-view no-sub-header">

	<div class="filters">

		<div v-if="showDetail">
			<button class="button neutral" @click="backToList()">Back To Report</button>
		</div>
		<div v-else>
			<div class="label-group">
				<label>Start</label>
				<input type="date" v-model="filters.start_date" :max="$today().clone().format('YYYY-MM-DD')">
			</div>
			<div class="label-group">
				<label>End</label>
				<input type="date" v-model="filters.end_date" :max="$today().clone().format('YYYY-MM-DD')">
			</div>
			<div class="label-group">
				<label></label>
				<div class="button small neutral" @click="getList()">Filter Dates</div>
			</div>

			<div class="divider"></div>
			<div :class="['extra-menu-item', loading ? 'disabled' : '']" @click="doExport()">Export CSV</div>
		</div>
	</div>

	<div v-if="showDetail" class="detail">

		<div class="detail-sub-header">
			<order-detail :orderDetail="orderDetail" />
		</div>
	</div>

	<div v-else class="list report-list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

		<div v-else>
			<div class="detail-sub-header right"><b>Total Fees: {{ $formatCurrency(total) }}</b></div>
			<table class="data-list" cellpadding="0" cellspacing="0">
				<thead>
					<tr>
						<th class="list">Date</th>
						<th class="list left">Order #</th>
						<th class="list left">Customer</th>
						<th class="list left">Description</th>
						<th class="list right">Fee</th>
					</tr>
				</thead>
				<tr v-for="item in list" class="clickable-list-item" @click="getItem(item)">
					<td class="list left">{{ item.date }}</td>
					<td class="list left">{{ item.order_number }}</td>
					<td class="list left">{{ item.customer }}</td>
					<td class="list left">{{ item.description }}</td>
					<td class="list right">{{ $formatCurrency(item.amount) }}</td>
				</tr>
			</table>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<iframe id="download" src="" style="display: none;"></iframe>

</div>

</template>

<script>
import OrderDetail from '@/components/OrderDetail.vue'
export default {
	name: 'payment-fees-external',
    components: {
        'order-detail': OrderDetail
    },
	data() {
		return {
            loading: false,
            message: '',
            messageStatus: '',
            messageTimeout: 0,
            list: [],
            total: 0,
            filters: {},
            orderDetail: {},
            showDetail: false,
			gettingExport: false
		}
	},
	created() {
		this.clearFilters(true)
	},
	methods: {
		clearFilters(getList) {
			this.filters = {
				page: 1,
				start_date: '',
				end_date: '',
				do_export: false
			}
			if (this.$route.query.start) {
				this.filters.start_date = this.$route.query.start
			} else {
				var oneMonthAgo = new Date()
				oneMonthAgo.setMonth(oneMonthAgo.getMonth() -1)
				this.filters.start_date = oneMonthAgo.toISOString().slice(0,10)
			}
			if (this.$route.query.end) {
				this.filters.end_date = this.$route.query.end
			} else {
				this.filters.end_date = new Date().toISOString().slice(0,10)
			}
			if (getList) {
				this.getList(1)
			}
		},
		getList() {
            if (this.loading) { return }
			this.loading = true
			if (this.filters.do_export) {
				this.message = 'Generating CSV for ' + this.list.length + ' items...'
			} else {
				this.message = 'Generating report...'
			}
			this.apiCall({ destination: 'get_list_payment_fees_external', data: this.filters }).then(obj => {
				this.loading = false
				this.messageStatus = obj.status
				if (this.filters.do_export) {
					this.filters.do_export = 0
					// accommodate live server filecache latency
					setTimeout(() => {
						this.message = 'Downloading CSV...'
						document.getElementById("download").src = obj.download_url
						this.messageTimeout = 2000
					}, 500)
				} else {
					this.list = obj.list
					this.total = obj.total
					this.message = ''
				}
			}).catch(err => {
				console.log(err)
			})
		},
		doExport() {
			this.filters.do_export = true
			this.getList()
		},
		getItem(item) {
			if (this.loading) { return }
			this.loading = true
			this.apiCall({ destination: 'get_item_order', data: { order_id: item.order_id } }).then(obj => {
				this.orderDetail.order = obj.order_detail
				this.orderDetail.billing = obj.order_billing_address
				this.orderDetail.shipping = obj.order_shipping_address
				this.orderDetail.items = obj.order_items
				this.orderDetail.discount = obj.order_discounts
				this.orderDetail.fees = obj.order_fees
				this.orderDetail.payments = obj.order_payments
				this.orderDetail.totals = obj.order_totals
				this.orderStatus = obj.order_detail.order_status_code
				this.loading = false
				this.showDetail = true
			}).catch(err => {
				console.log(err)
			})
		},
		backToList() {
			this.showDetail = false
			this.orderDetail = {}
		}
	}
}
</script>
